import React, { useMemo } from 'react';
import NinjaTable from 'components/tables/NinjaTable';
import { Flex, Tooltip, Button } from 'antd';
import { CountryFormatter } from 'modules/CRMModule/formatters';
import useQueryParams from 'hooks/useQueryParams';
import { mdiMapMarkerPath } from '@mdi/js';
import Icon from '@mdi/react';
import Ninja from '@ninja';
import TrafficLevelColumn from 'modules/ReportModule/components/TrafficLevelColumn';
import { DateFormatter } from 'components/tables/NinjaTable/formatters';
import AnonymousUserFormatter from 'modules/ReportModule/formatters/AnonymousUserFormatter';
import PathFormatter from 'modules/ReportModule/formatters/PathFormatter';
import { useJourneyReport } from 'modules/ReportModule/context/useJourneyReport';

const TrafficReportingRecent = () => {
  const { filter } = useJourneyReport();
  const { setUrlParams } = useQueryParams();

  const columns = [
    {
      key: 'last_seen',
      name: 'Last Seen',
      renderCell: ({ row }) => (
        <span className='grid text-xs'>
          <span className='text-sm font-medium'>{row?.last_seen || '-'}</span>
        </span>
      ),
    },
    {
      key: 'last_seen_date',
      name: 'Last Seen Date',
      renderCell: DateFormatter,
    },
    { key: 'path', name: 'Path', renderCell: PathFormatter, minWidth: 150, resizable: true },
    {
      key: 'user_id',
      name: 'User ID',
      minWidth: 240,
      resizable: true,
      renderCell: AnonymousUserFormatter,
    },
    {
      key: 'session_id',
      name: 'Session ID',
      minWidth: 150,
      resizable: true,
      renderCell: ({ row }) => (
        <Flex align='center' gap={4}>
          <Tooltip title='Open Session Journey'>
            <Button
              type='text'
              size='small'
              iconPosition='end'
              icon={<Icon path={mdiMapMarkerPath} size={0.7} color={Ninja.colors.info} />}
              onClick={() => {
                setUrlParams({
                  report: 'user_journey',
                  session_id: row.session_id,
                });
              }}
            >
              <span className='text-sm font-medium text-info'>{row.session_id}</span>
            </Button>
          </Tooltip>
        </Flex>
      ),
    },
    {
      key: 'country',
      name: 'Country',
      renderCell: ({ row }) =>
        row.country ? <CountryFormatter value={row.country} editable={false} /> : 'N/A',
    },
  ];

  const allLevelColumns = useMemo(() => {
    return Object.keys(TrafficLevelColumn).map((key) => ({
      ...TrafficLevelColumn[key],
      resizable: true,
      minWidth: 200,
      sortable: true,
    }));
  }, []);

  return (
    <NinjaTable
      cardProps={{ disable: true }}
      date_key='trafficReportingRecent'
      dataProvider='trafficReportingRecent'
      columns={[...allLevelColumns, ...columns]}
      disableFooter
      queryParams={{
        filters: {
          ...filter,
        },
      }}
    />
  );
};

export default TrafficReportingRecent;
